<template>
  <div>
    <action-bar></action-bar>
    <main class="content">
      <div v-if="tag">
        <h1>
          Tag bearbeiten
          <br />
          <small class="text-muted">{{tag.name.text}}</small>
        </h1>
        <text-input :value="tag.name" label="Name" ref="name"></text-input>
        <long-text-input :value="tag.description" label="Kurzbeschreibung" ref="description"></long-text-input>
        <long-text-input :value="tag.longDescription" label="Beschreibung" ref="longDescription"></long-text-input>
        <div class="form-group">
          <label for="#chapter-position">Typ</label>
          <multiselect
            id="type"
            v-model="type"
            label="label"
            :options="typeOptions"
            :show-labels="false"
          ></multiselect>
        </div>
        <button class="btn btn-primary" @click="save">Save</button>
      </div>
      <loading v-else></loading>
    </main>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      tag: false,
      typeValue: 0,
      typeOptions: [
        { value: 0, label: "Weder noch" },
        { value: 1, label: "Akteure" },
        { value: 2, label: "Themen" }
      ]
    };
  },
  watch: {
    tag(newTag) {
      this.typeValue = newTag.type;
    }
  },
  asyncComputed: {
    tag() {
      return axios
        .get(
          "/api/" + store.state.language + "/tag/" + this.$route.params.tagId
        )
        .then(({ data }) => data.result);
    }
  },
  computed: {
    type: {
      get() {
        return this.typeOptions.find(option => option.value === this.typeValue);
      },
      set(newType) {
        this.typeValue = newType.value;
      }
    }
  },

  methods: {
    saveTag() {
      const form = new FormData();

      form.append("edit_tag[type]", this.typeValue);
      form.set("edit_tag[submit]", null);

      return axios.post(
        "/api/" +
          store.state.language +
          "/tag/" +
          this.$route.params.tagId +
          "/edit",
        form
      );
    },
    save() {
      Promise.all([
        this.saveTag(),
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save()
      ]);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/tag/Edit.vue